import { Box, Button, Typography } from "@mui/material";

interface Props {
  /** True when filters or a search term are narrowing the list. */
  filtered: boolean;
  /** Plural noun, e.g. "surveys". */
  noun: string;
  /** Offered only when nothing exists yet and the reader can create one. */
  action?: { label: string; onClick: () => void };
  onClearFilters?: () => void;
}

/**
 * "Nothing here yet" and "nothing matches your filters" are different
 * situations and must not share wording -- telling someone their filters
 * matched nothing when they set none sends them hunting for a filter.
 */
export function EmptyState({ filtered, noun, action, onClearFilters }: Props) {
  return (
    <Box sx={{ py: 5, textAlign: "center" }}>
      <Typography color="text.secondary" sx={{ mb: action || onClearFilters ? 1.5 : 0 }}>
        {filtered ? `No ${noun} match your filters.` : `No ${noun} yet.`}
      </Typography>
      {filtered && onClearFilters && <Button onClick={onClearFilters}>Clear filters</Button>}
      {!filtered && action && <Button onClick={action.onClick}>{action.label}</Button>}
    </Box>
  );
}
